// Los precios en backend/nexo/knowledge/*.json (fuente única, ver
// backend/nexo/pricing.py) se guardan como números en pesos mexicanos sin
// separadores. Este helper los formatea para mostrarlos en la UI.
export const formatPriceMXN = (price) =>
  price == null ? null : Number(price).toLocaleString("es-MX");
